import parsePhoneNumber from 'libphonenumber-js'

export default {
  methods: {
    cleanPhone(number) {
      const phoneNumber = parsePhoneNumber(number, 'US')
      if (phoneNumber) {
        return phoneNumber.formatNational()
      }
      return number
    }
  }
}
